import PharmacyList from "@/components/pharmacies/PharmacyList.vue";

const pharmacyRoutes = [
  { path: "/pharmacies", name: "pharmacies", component: PharmacyList },
  {
    // UC-REG-296: publicación de la nómina diaria de farmacias de guardia
    // (admin). Visible en el sidebar solo con VUE_APP_PHARMACY_DUTY_ENABLED.
    path: "/pharmacy-duty",
    name: "pharmacy-duty",
    component: () =>
      import(
        /* webpackChunkName: "pharmacies" */ "@/components/pharmacies/PharmacyDutyAdmin.vue"
      ),
  },
];

export default pharmacyRoutes;
